import * as React from 'react';
import * as _ from 'lodash';
import { IDonorInfoForCryoResponse } from '@nkr/store/nkr-lab';
import { connect, Dispatch } from 'react-redux';
import { IApplicationState, AppActionCreators, NkrLabActionCreators } from '@nkr/store/index';
import { IBaseResponse } from '@nkr/models/index';
import { RouteComponentProps } from 'react-router';
import { toast } from 'react-toastify';
import { Button, FormControl, InputGroup } from 'react-bootstrap';
import styled from 'styled-components';

const LabelWrapper = styled.div`
    font-weight: bold;
`;

interface IProps extends RouteComponentProps<{ donorAlias: string }> { };

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getDonorForCryoManagement: (donorAlias: string) => Promise<IDonorInfoForCryoResponse>,
    markCryoReceived: (donorId: number) => Promise<IBaseResponse>,
    updateCryoVials: (cryoCount: number, donorId: number) => Promise<IBaseResponse>,
    createHistoHlaOrder: (donorId: number) => Promise<IBaseResponse>
}

type TProps =
    IProps
    & IStateProps
    & IDispatchProps;

interface IState {
    donorId: number;
    alias: string;
    centerAlias: string;
    fullBloodType: string;
    hasCryoAtNkrLab: string;
    numberOfVials: number;
    donorName: string;
    dob: string;
    gender: string;
    donorHasTyping: boolean;
}


class NkrlabDonorOptions extends React.Component<TProps, IState> {
    readonly state: IState = {
        donorId: 0,
        alias: '',
        centerAlias: '',
        fullBloodType: '',
        hasCryoAtNkrLab: '',
        numberOfVials: 0,
        donorName: '',
        dob: '',
        gender: '',
        donorHasTyping: false
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        let { donorAlias } = this.props.match.params;

        this.props.showLoading('Getting donor data, one moment please...').then(() => {
            this.props.getDonorForCryoManagement(donorAlias).then(response => {
                if (response.data.success) {
                    let { donorId, alias, centerAlias, fullBloodType, hasCryoAtNkrLab, numberOfVials, donorName, dob, gender, donorHasTyping } = response.data.results;

                    this.setState({
                        donorId,
                        alias,
                        centerAlias,
                        fullBloodType,
                        hasCryoAtNkrLab,
                        numberOfVials,
                        donorName,
                        dob,
                        gender,
                        donorHasTyping
                    }, () => {
                        this.props.hideLoading();

                    });
                } else {
                    this.props.hideLoading();
                }
            });
        });
    }

    handleVialCountChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let numberOfVials = parseInt(e.currentTarget.value);
        this.setState({ numberOfVials });
    }

    handleMarkKitReceivedSubmit = () => {
        let donorId = this.state.donorId;

        this.props.showLoading('Marking cryo received, one moment please...').then(() => {
            this.props.markCryoReceived(donorId).then(response => {
                this.props.hideLoading();
            });
        });
    }

    handleReturnHomeSubmit = () => {
        window.location.href = `/nkr-lab`;
    }

    handleCryoVialCountUpdateSubmit = () => {
        let { donorId, numberOfVials: vials } = this.state;

        this.props.showLoading('Updating cryo vial count, one moment please...').then(() => {
            this.props.updateCryoVials(vials, donorId).then(response => {
                if (response.data.success) {
                    toast.success('Successfully updated the # of vials...');

                    this.getData();
                } else {
                    this.props.hideLoading();
                }
            });
        });
    }

    handleLabRequisitionSubmit = () => {
        if (this.state.donorHasTyping) {
            toast.error(
                'Histo order not needed. Donor typing already on file!', {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 6000
            });

            return;
        }

        let donorId = this.state.donorId;

        if (donorId > 0) {
            this.props.createHistoHlaOrder(donorId).then((response: any) => {
                toast.success('Histo order created successfully!', {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 5000
                });

                const file = new Blob(
                    [response.data],
                    { type: 'application/pdf' }
                );

                //Build a URL from the file
                const fileURL = URL.createObjectURL(file);

                //Open the URL on new Window
                window.open(fileURL);
            });
        }
    }

    render = () => {
        let data = this.state;

        return (
            <div className='container'>
                <div className='row' style={{ marginBottom: 20 }}>
                    <div className='col-xs-12' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h1 style={{ margin: 0 }}>NKR Lab Donor Management</h1>
                        <div><a className='btn btn-link' onClick={this.handleReturnHomeSubmit}>Return to Home Page</a></div>
                    </div>
                </div>

                <div className='well'>
                    <div className='row' style={{ marginBottom: 10 }}>
                        <LabelWrapper className='col-xs-12 col-md-3'>Donor Alias:</LabelWrapper>
                        <div className='col-xs-12 col-md-3'>{data.alias}</div>
                        <LabelWrapper className='col-xs-12 col-md-3'>Donor Name:</LabelWrapper>
                        <div className='col-xs-12 col-md-3'>{data.donorName}</div>
                    </div>

                    <div className='row' style={{ marginBottom: 10 }}>
                        <LabelWrapper className='col-xs-12 col-md-3'>Donor Hospital:</LabelWrapper>
                        <div className='col-xs-12 col-md-3'>{data.centerAlias}</div>
                        <LabelWrapper className='col-xs-12 col-md-3'>Donor DOB:</LabelWrapper>
                        <div className='col-xs-12 col-md-3'>{data.dob}</div>
                    </div>

                    <div className='row' style={{ marginBottom: 10 }}>
                        <LabelWrapper className='col-xs-12 col-md-3'>Blood Type:</LabelWrapper>
                        <div className='col-xs-12 col-md-3'>{data.fullBloodType}</div>
                        <LabelWrapper className='col-xs-12 col-md-3'>Donor Gender:</LabelWrapper>
                        <div className='col-xs-12 col-md-3'>{data.gender}</div>
                    </div>

                    <div className='row' style={{ marginBottom: 10 }}>
                        <LabelWrapper className='col-xs-12 col-md-3'>Has Cryo:</LabelWrapper>
                        <div className='col-xs-12 col-md-3'>{data.hasCryoAtNkrLab}</div>
                        <LabelWrapper className='col-xs-12 col-md-3'>Has High Res Typing:</LabelWrapper>
                        <div className='col-xs-12 col-md-3'>{data.donorHasTyping ? 'Yes' : 'No'}</div>
                    </div>

                </div>

                <div className='row' style={{ marginBottom: 10 }}>
                    <div className='col-xs-12 text-center'>
                        <Button disabled={data.donorHasTyping} bsStyle='info' onClick={this.handleLabRequisitionSubmit}>Lab Requisition</Button>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        app: appState.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getDonorForCryoManagement: (donorAlias) => {
            return dispatch(NkrLabActionCreators.getDonorForCryoManagement(donorAlias));
        },
        markCryoReceived: (donorId) => {
            return dispatch(NkrLabActionCreators.markCryoReceived(donorId));
        },
        updateCryoVials: (cryoVials, donorId) => {
            return dispatch(NkrLabActionCreators.updateCryoVials(cryoVials, donorId));
        },
        createHistoHlaOrder: (donorId) => {
            return dispatch(NkrLabActionCreators.createHistoHlaOrder(donorId));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(NkrlabDonorOptions)